module.exports = __webpack_public_path__ + "static/media/REW_Newsearch.cc072617.jpg";